import React from 'react';
import { useNavigate } from 'react-router';

import StatusCell from '../../../components/Badge/StatusCell';
import ExitHistoryIcon from '../../../components/Icons/ExitHistoryIcon';
import RehireIcon from '../../../components/Icons/RehireIcon';
import UserProfileIcon from '../../../components/Icons/UserProfileIcon';
import ExitHistoryModal from '../../../components/Modal/ModalActions/ExitHistoryModal/ExitHistoryModal';
import RehireDriverLookupFlowModal from '../../../components/Modal/ModalActions/RehireDriverLookupFlowModal/RehireDriverLookupFlowModal';
import Table from '../../../components/Table/Table';
import ActionRowWithModal from '../../../components/Table/TableAccessories/ActionRowWithModal';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import TableDateTimeFormatter from '../../../components/Table/TableAccessories/TableDateTimeFormatter';
import TableHasConflictTag from '../../../components/Table/TableAccessories/TableHasConflictTag';
import TablePhoneFormatter from '../../../components/Table/TableAccessories/TablePhoneFormatter';
import ViewDetails from '../../../components/Table/TableAccessories/ViewDetails';
import ExitedListRowCell from '../../../components/Table/TableMobileRowCell/ExitedListRowCell';
import { DRIVER_PERFORMANCE_REPORT } from '../../../routes/routeConstants';
import ManageDriver from './ManageDriver';

const ExitedDriversList = () => {
  const navigate = useNavigate();
  return (
    <Table
      tableFilterBoxFeatures={{
        showSearchBox: true,
        searchBoxPlaceholder: 'Search exited driver name...',
        rightAttr: [
          {
            type: 'regular',
            comp: <ManageDriver />,
          },
        ],
      }}
      tableHeader={{
        'Last updated date': 'endDate',
        'Driver Name': 'name',
        'Email Address': 'email',
        Phone: 'phoneNumber',
        Gender: 'gender',
      }}
      tableDataSourceUrl='api/v1/company/drivers?status=Exited'
      cellsCustomComp={{
        createdAt: <TableDateTimeFormatter dataKey='createdAt' />,
        status: <StatusCell statusKey='status' />,
        phoneNumber: <TablePhoneFormatter dataKey='phoneNumber' />,
        // name: <TableNameCapitalizeFormatter dataKey='name' />,
        name: <TableHasConflictTag dataKey='name' isRehiredKey='rehired' />,
        endDate: <TableDateFormatter dataKey='endDate' />,
      }}
      moreOptionsComponents={[
        <ViewDetails
          key='View Driver Profile'
          label='View Driver Profile'
          width='257px'
          icon={<UserProfileIcon />}
          action={({ data }) =>
            navigate(
              `/${DRIVER_PERFORMANCE_REPORT}/${encodeURIComponent(data.nin || '-')}/${encodeURIComponent(data.driverId || data.id || '-')}/${encodeURIComponent(data.timeSpent || '-')}/${encodeURIComponent(data.name || '-')}/${encodeURIComponent(data.rating || '-')}/${encodeURIComponent(data.profilePicture || '-')}/${encodeURIComponent(data.verificationStatus || '-')}`,
            )
          }
        />,

        <ActionRowWithModal
          key='Rehire Driver'
          label='Rehire Driver'
          width='257px'
          icon={<RehireIcon />}
          // modalCompFn={(data) => <RehireDispatcherModal data={data} />}
          modalCompFn={(data) => (
            <RehireDriverLookupFlowModal dispatcherData={data} />
          )}
        />,

        <ActionRowWithModal
          key='View Exit History'
          label='View Exit History'
          width='257px'
          icon={<ExitHistoryIcon />}
          modalCompFn={(data) => <ExitHistoryModal data={data} />}
        />,
      ]}
      mobileCellComp={<ExitedListRowCell />}
    />
  );
};

export default ExitedDriversList;
